<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSun, faMoon, faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons';

library.add(faSun, faMoon, faCircleHalfStroke);

const STORAGE_KEY = 'm2d2-theme';
const MODES = [
  { key: 'system', label: 'System', icon: ['fas', 'circle-half-stroke'] },
  { key: 'light',  label: 'Light',  icon: ['fas', 'sun'] },
  { key: 'dark',   label: 'Dark',   icon: ['fas', 'moon'] },
];

// DaisyUI uses [data-theme=X] attribute selectors to activate themes.
// "light" → m2d2 (custom light theme); "dark" → m2d2-dark (custom dark theme).
// "system" removes data-theme so DaisyUI's prefersdark logic kicks in:
// m2d2 (default:true) for light OS, m2d2-dark (prefersdark:true) for dark OS.
const THEME_ATTR = { light: 'm2d2', dark: 'm2d2-dark' };

function applyMode(mode) {
  if (mode === 'system') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', THEME_ATTR[mode]);
  }
}

function loadMode() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return MODES.find(m => m.key === stored) ? stored : 'system';
}

export default {
  components: { FontAwesomeIcon },

  data() {
    return {
      mode: loadMode(),
      modes: MODES,
    };
  },

  computed: {
    current() {
      return MODES.find(m => m.key === this.mode);
    },
  },

  mounted() {
    applyMode(this.mode);
  },

  methods: {
    select(key) {
      this.mode = key;
      localStorage.setItem(STORAGE_KEY, key);
      applyMode(key);
      document.activeElement?.blur();
    },
  },
};
</script>

<template>
  <div class="dropdown dropdown-end ml-2">
    <button tabindex="0" class="btn btn-ghost btn-sm" :title="`Theme: ${current.label}`">
      <FontAwesomeIcon :icon="current.icon" />
    </button>
    <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 border border-base-300 w-36 z-50">
      <li v-for="m in modes" :key="m.key">
        <button
          class="flex items-center gap-2"
          :class="m.key === mode ? 'menu-active' : ''"
          @click="select(m.key)"
        >
          <FontAwesomeIcon :icon="m.icon" class="w-4" />
          {{ m.label }}
        </button>
      </li>
    </ul>
  </div>
</template>
